import { Element } from "@nkitaa/builder-engine";
import { TextChild } from "./textChild";

function SectionHeader({
  isVisibleHeadline,
  textHeadline,
  submittedTextHeadline,
  fontSizeHeadline,
  textAlignHeadline,
  isVisibleHeader,
  textHeader,
  submittedTextHeader,
  fontSizeHeader,
  textAlignHeader,
  isVisibleText,
  textText,
  submittedTextText,
  fontSizeText,
  textAlignText,
  isSubmitted,
  enableSubmittedState,
}: {
  isVisibleHeadline?: boolean;
  textHeadline?: string;
  submittedTextHeadline?: string;
  fontSizeHeadline?: string;
  textAlignHeadline?: "left" | "center" | "right" | "justify";
  isVisibleHeader?: boolean;
  textHeader?: string;
  submittedTextHeader?: string;
  fontSizeHeader?: string;
  textAlignHeader?: "left" | "center" | "right" | "justify";
  isVisibleText?: boolean;
  textText?: string;
  submittedTextText?: string;
  fontSizeText?: string;
  textAlignText?: "left" | "center" | "right" | "justify";
  isSubmitted?: boolean;
  enableSubmittedState?: boolean;
}) {
  return (
    <>
      <Element
        is={TextChild}
        id="headline"
        isVisible={isVisibleHeadline}
        text={textHeadline}
        submittedText={submittedTextHeadline}
        isSubmitted={isSubmitted}
        enableSubmittedState={enableSubmittedState}
        fontSize={fontSizeHeadline}
        header
        headingLevel="h2"
        textAlign={textAlignHeadline}
      />
      <Element
        is={TextChild}
        id="header"
        isVisible={isVisibleHeader}
        text={textHeader}
        submittedText={submittedTextHeader}
        isSubmitted={isSubmitted}
        enableSubmittedState={enableSubmittedState}
        fontSize={fontSizeHeader}
        header
        headingLevel="h1"
        textAlign={textAlignHeader}
      />
      <Element
        is={TextChild}
        id="text"
        isVisible={isVisibleText}
        text={textText}
        submittedText={submittedTextText}
        isSubmitted={isSubmitted}
        enableSubmittedState={enableSubmittedState}
        fontSize={fontSizeText}
        textAlign={textAlignText}
      />
    </>
  );
}

export { SectionHeader };
